import React from "react";

import type { BlockProps } from "@admin/components/Content/ContentBlocks";

type Props = BlockProps<undefined>;

export default function OtherNewsBlock({ index }: Props) {
    return <input type="hidden" name={`blocks[${index}][value]`} value="" />;
}
